export const getProjectAppId = {
	wenwen: "101401138",
	baike: "101401138",
	ld: "101401138",
	zhinan: "101401138",
	zhuanjia: "101401138",
	kexue: "101401138",
};
